'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.accordions = exports.default = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var accordion = function accordion(accordionSelector) {
    var selectors = {
        row: '.js-accordion__row',
        activeRow: '.js-accordion__row_active',
        inactiveRow: ':not( .js-accordion__row_active )',
        header: '.js-accordion__header',
        content: '.js-accordion__content'
    };
    var dataAttr = {
        mode: 'mode'
    };

    var classes = {
        hidden: 'hidden',
        headerActive: 'ui-accordion__header_active',
        activeRow: 'js-accordion__row_active'
    };
    var $container = (0, _jquery2.default)(accordionSelector);
    var mode = '';
    var $rows = [];
    function setUp() {
        mode = $container.data(dataAttr.mode);
        $rows = $container.children(selectors.row);
    }
    function isDefaultMode() {
        return mode === 'default';
    }
    function expandRow(index, row) {
        var $row = (0, _jquery2.default)(row);
        $row.addClass(classes.activeRow);
        $row.children(selectors.content).removeClass(classes.hidden);
        $row.children(selectors.header).addClass(classes.headerActive);
    }
    function collapseRow(index, row) {
        var $row = (0, _jquery2.default)(row);
        $row.removeClass(classes.activeRow);
        $row.children(selectors.content).addClass(classes.hidden);
        $row.children(selectors.header).removeClass(classes.headerActive);
    }
    function toggleRow(event) {
        var $row = (0, _jquery2.default)(event.currentTarget).parent(selectors.row);

        if (!event.isDefaultPrevented()) {
            event.preventDefault();
            if ($row.is(selectors.activeRow)) {
                collapseRow(0, $row);
            } else {
                expandRow(0, $row);
                if (isDefaultMode()) {
                    $row.siblings().each(_jquery2.default.proxy(collapseRow, this));
                }
            }
        }
        if ($rows.filter(selectors.inactiveRow).length) {
            (0, _jquery2.default)(document).trigger('rp.accordion.collapsed');
        } else {
            (0, _jquery2.default)(document).trigger('rp.accordion.expanded');
        }
    }
    function toggleRows(callback, event) {
        if (!event.isDefaultPrevented()) {
            event.preventDefault();
            $rows.each(_jquery2.default.proxy(callback, this));
        }
    }
    function bindEvents() {
        $container.on('click', selectors.header, _jquery2.default.proxy(toggleRow, this));
        $container.on('rp.accordion.expandAll', _jquery2.default.proxy(toggleRows, this, expandRow));
        $container.on('rp.accordion.collapseAll', _jquery2.default.proxy(toggleRows, this, collapseRow));
    }
    function init() {
        setUp();
        bindEvents();
    }
    init();
    return {
        expandRow: expandRow,
        collapseRow: collapseRow
    };
};

var accordions = function accordions() {
    var hashOfAccordions = {};
    var selectors = {
        container: '.js-accordion'
    };
    var attributes = {
        name: 'data-accordion-name'
    };
    function initAccordion(index, element) {
        var name = (0, _jquery2.default)(element).attr(attributes.name);
        if (name === undefined) {
            accordion(element);
            return;
        }
        hashOfAccordions[name] = accordion(element);
    }
    function init() {
        var $accordion = (0, _jquery2.default)(selectors.container);
        $accordion.each(_jquery2.default.proxy(initAccordion, this));
    }
    init();
    return hashOfAccordions;
};

exports.default = accordion;
exports.accordions = accordions;


//////////////////
// WEBPACK FOOTER
// ./~/rp-gui-guide/lib/js/accordion.js
// module id = 1419
// module chunks = 1